import "bootstrap/dist/css/bootstrap.min.css";
import AppRouter from "./components/Router";
function App() {
  return (
    <div>
      <AppRouter />
    </div>
  );
}

export default App;
